// React & Libraries
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import { Typography, Stack, Box } from '@mui/material';
import { Icon } from '@iconify/react';
// Components
import CommonLoading from '../CommonComponent/CommonLoading';
import CommonDialog from '../CommonComponent/CommonDialog';
import CommonButton from "@/views/CommonComponent/CommonButton";

// Styled Components
import { Root } from '../../common/Styled/CommonStyled';
import { ListTitle, ExImage, StyledAccordion, StyledAccordionSummary, StyledAccordionDetails, LanguageItem } from './Styled/LanguageStyled';
import { ContentsBox } from "./Styled/SettingStyled";
import TitleBox from '../CommonComponent/TitleBox';

// Assets & Images
import PokoroPen from "@/common/Images/PokoroPen.png";

// Utils & Hooks
import { usePenStatus } from '../../nativebridge/PenStatus';
import { NativeToJsBridge, NativeToJsEventName } from '../../nativebridge/NativeToJs';
import { c } from "../../theme/colorUtils";
import { useToast } from '../../components/useToast';
import {
  disConnectPokoro,
  customSendTok,
  customSendSetting,
} from "../../nativebridge/JsToNative";

function LanguageSetting(props) {
  const { intl } = props;
  const languageMap = {
    KR: "한국어",
    US: "English",
    JP: "日本語",
    CN: "简体中文",
    ES: "Español",
    DE: "Deutsch",
    XA: "ٱلسُّعُوْدِيَّة",
  };

  const languageText = {
    KR: intl.formatMessage({ id: 'KR' }),
    US: intl.formatMessage({ id: 'US' }),
    JP: intl.formatMessage({ id: 'JP' }),
    CN: intl.formatMessage({ id: 'CN' }),
    ES: intl.formatMessage({ id: 'ES' }),
    DE: intl.formatMessage({ id: 'DE' }),
    XA: intl.formatMessage({ id: 'XA' }),
  };

  const history = useHistory();
  const location = useLocation();
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isInitialKR, setIsInitialKR] = useState(true);
  const [open, setOpen] = useState(false);
  const { showDeleteToast, showErrorToast, showSuccessToast } = useToast();
  const queryParams = new URLSearchParams(location.search);
  const showToast = queryParams.get("connectByPokoroSetting") === "true";
  const reqSetServerRef = React.useRef(false); // 클로저 문제 해결을 위해 Ref 사용

  const handleClickOpen = () => {
    // 랭귀지 변화값 펜에 전달
    // API에 대한 응답 받으면 그때 setOpen(true);
    setLoading(true);
    // setOpen(true);

    const deviceInfo = globalPenStatus?.deviceInfo ?? {};
    let lang_main = deviceInfo.lang_listening_main;
    let lang_sub = deviceInfo.lang_listening_sub;
    const settingData = {
      messageType: "POKORO2_Settings",
      payload: {
        lang_system: deviceInfo.lang_system,
        lang_speaking: deviceInfo.lang_speaking,
        lang_listening_main: lang_main,
        lang_listening_sub: lang_sub,
      },
    };
    reqSetServerRef.current = true;
    console.log(`=== LanguageSetting handleClickOpen customSendSetting:${reqSetServerRef.current}`);
    customSendSetting(JSON.stringify(settingData));
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    // BT연결 끊고 홈화면
    disConnectPokoro();
    setOpen(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
    history.push("/home");
  };

  const onDeviceDisConnected = () => {
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
    showErrorToast(intl.formatMessage({ id: "disconnect_dialog_Title" }));

    // 토스트 메시지를 3초 동안 보여준 후 설정 페이지로 이동
    setTimeout(() => {
      history.push('/pokoroSetting');
    }, 3000);
  };



  useEffect(() => {
    window.scrollTo(0, 0);
    // 페이지 진입 시 포코로 연결 완료 토스트 팝업 표시
    if (showToast) {
      showSuccessToast(
        <span style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "connect_complete_toast" })} {/* 포코로 연결이 완료되었습니다. */}
        </span>
      );
    }

  }, []);

  // 언어 기본값 세팅
  useEffect(() => {
    setGlobalPenStatus((prevStatus) => {
      const deviceInfo = prevStatus.deviceInfo || {};
      return {
        ...prevStatus,
        deviceInfo: {
          ...deviceInfo,
          lang_speaking: deviceInfo.lang_speaking || 'KR',
          lang_listening_main: deviceInfo.lang_listening_main || 'KR',
          lang_listening_sub: deviceInfo.lang_listening_sub || null,
        },
      };
    });
  }, [setGlobalPenStatus]);

  const handleBack = () => {
    history.push("/pokoroSetting");
    // history.goBack();
  };

  useEffect(() => {
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        console.log(`=== LanguageSetting handleClickOpen onCustomSendResult:${reqSetServerRef.current} --${jsonStr}`);
        console.log(jsonStr);
        if (reqSetServerRef.current) {
          setLoading(false);
          reqSetServerRef.current = false;
          setOpen(true);
        }

      }

    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        // const jsonStr = event;
        onDeviceDisConnected();
      }
    );


    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult,
        () => setLoading(false)
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
    };
  }, []);

  const handleAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleLanguageChange = (type, languageCode) => {
    // 어떤값이 변경되었는지 확인후 펜에 전달해야함
    if (type === 'main') {
      if (globalPenStatus.deviceInfo.lang_listening_main === languageCode) {
        // 첫 번째 언어를 다시 클릭해도 아무 동작 안 함
        return;
      }
      // 첫 번째 언어를 바꾸되, sub는 그대로 유지
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo,
          lang_listening_main: languageCode,
        },
      }));
    } else if (type === 'sub') {
      if (globalPenStatus.deviceInfo.lang_listening_sub === languageCode) {
        // 두 번째 언어 해제
        setGlobalPenStatus((prevStatus) => ({
          ...prevStatus,
          deviceInfo: {
            ...prevStatus.deviceInfo,
            lang_listening_sub: null,
          },
        }));
      } else {
        // sub 선택 시 main과 중복되지 않도록
        setGlobalPenStatus((prevStatus) => ({
          ...prevStatus,
          deviceInfo: {
            ...prevStatus.deviceInfo,
            lang_listening_sub: languageCode,
          },
        }));
      }
    } else if (type === 'speaking') {
      // 내가 말하는 언어 선택
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo,
          lang_speaking: languageCode,
        },
      }));
    }
  };


  return (
    <Root sx={{ position: 'relative', overflow: 'scroll' }}>
      <Stack width="100%" height="100vh">
        <TitleBox
          title={intl.formatMessage({ id: "language_settings" })} /* 언어 설정 */
          subtitle={intl.formatMessage({ id: "talk_language_settings_description" })} /* 포코로와 대화를 위한 언어를 설정합니다. */
          onBack={handleBack}
        />
        
        <ContentsBox className="setting-box" sx={{ flex: 1, paddingBottom: '100px' }}>
          <Box
            sx={{
              width: '100%',
              overflow: 'auto',
              paddingRight: '4px'
            }}
          >
            <Stack gap={1}>
              <StyledAccordion
                expanded={expanded === 'speaking'}
                onChange={handleAccordion('speaking')}
              >
                <StyledAccordionSummary
                  expandIcon={<Icon icon={expanded === 'speaking' ? 'material-symbols:keyboard-arrow-down' : 'weui:arrow-outlined'} fontSize={20} />}
                  aria-controls="speaking-content"
                  id="speaking-header"
                >
                  <Typography variant="body1" sx={{ flex: 1 }}>
                    {intl.formatMessage({ id: "speaking_language" })}{/* 내가 말하는 언어 */}
                  </Typography>
                  <Typography className="subTxt" mr={0.5}>
                    {languageText[globalPenStatus.deviceInfo.lang_speaking]}
                  </Typography>
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    {intl.formatMessage({ id: "speaking_language_description" })}{/* 포코로에게 말을 걸 때 사용할 언어를 선택해주세요. */}
                  </Typography>
                  <Stack gap={1}>
                    {Object.keys(languageMap).map((languageCode) => (
                      <LanguageItem
                        key={languageCode}
                        selected={globalPenStatus.deviceInfo.lang_speaking === languageCode}
                        onClick={() => handleLanguageChange('speaking', languageCode)}
                      >
                        <Typography variant="body1">
                          {intl.formatMessage({ id: languageCode })}
                        </Typography>
                        <Typography variant="caption" className="subTxt">
                          {languageMap[languageCode]}
                        </Typography>
                      </LanguageItem>
                    ))}
                  </Stack>
                </StyledAccordionDetails>
              </StyledAccordion>
              <StyledAccordion
                expanded={expanded === 'main'}
                onChange={handleAccordion('main')}
              >
                <StyledAccordionSummary
                  expandIcon={<Icon icon={expanded === 'main' ? 'material-symbols:keyboard-arrow-down' : 'weui:arrow-outlined'} fontSize={20} />}
                  aria-controls="main-content"
                  id="main-header"
                >
                  <Typography variant="body1" sx={{ flex: 1 }}>
                    {intl.formatMessage({ id: "pokoro_speaking_language" })}{/* 포코로가 말하는 언어 */}
                  </Typography>
                  <Typography className="subTxt" mr={0.5}>
                    {[globalPenStatus.deviceInfo.lang_listening_main, globalPenStatus.deviceInfo.lang_listening_sub]
                      .filter(Boolean) // 값이 있는 것만 남김
                      .map((code) => languageText[code]) // 코드 → 언어 텍스트
                      .join(' | ')} {/* ' | ' 로 연결 */}
                  </Typography>
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                  <Stack direction="row" alignItems="center" justifyContent="center" mb={3}>
                    <ExImage className="exImage" sx={{ textAlign: 'center' }}>
                      <img src={PokoroPen} alt="포코로 마이크" width="60%" />
                    </ExImage>
                    <Typography variant="body2" color="text.secondary" sx={{ flex: 2 }}>
                      {intl.formatMessage({ id: "pokoro_speaking_language_description01" })}{/* 포코로가 말하는 언어는 */}<br />
                      <b style={{ color: '#FE536B' }}>
                        {intl.formatMessage({ id: "pokoro_speaking_language_description02" })}{/* 2개까지 선택이 가능 */}
                      </b>
                      {intl.formatMessage({ id: "pokoro_speaking_language_description03" })}{/* 하며\n선택한 언어는 Fn키를 짧게 눌러 전환합니다. */}
                    </Typography>
                  </Stack>
                  <Stack gap={1}>
                    <ListTitle>MAIN</ListTitle>
                    {Object.keys(languageMap).map((languageCode) => (
                      <LanguageItem
                        key={languageCode}
                        selected={globalPenStatus.deviceInfo.lang_listening_main === languageCode} // 선택된 국가 코드 확인
                        onClick={() => handleLanguageChange("main", languageCode)} // 국가 코드 설정
                        disabled={globalPenStatus.deviceInfo.lang_listening_sub === languageCode}
                      >
                        <Typography variant="body1">
                          {intl.formatMessage({ id: languageCode })}
                        </Typography>
                        <Typography variant="caption" className="subTxt">
                          {languageMap[languageCode]}
                        </Typography>
                      </LanguageItem>
                    ))}
                  </Stack>
                  <Stack gap={1} mt={3}>
                    <ListTitle>SUB</ListTitle>
                    {Object.keys(languageMap).map((languageCode) => (
                      <LanguageItem
                        key={languageCode}
                        selected={globalPenStatus.deviceInfo.lang_listening_sub === languageCode} // 선택된 국가 코드 확인
                        onClick={() => handleLanguageChange("sub", languageCode)} // 국가 코드 설정
                        disabled={globalPenStatus.deviceInfo.lang_listening_main === languageCode}
                      >
                        <Typography variant="body1">
                          {intl.formatMessage({ id: languageCode })}
                        </Typography>
                        <Typography variant="caption" className="subTxt">
                          {languageMap[languageCode]}
                        </Typography>
                      </LanguageItem>
                    ))}
                  </Stack>
                </StyledAccordionDetails>
              </StyledAccordion>
            </Stack>
          </Box>
        </ContentsBox>
      </Stack>

      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          maxWidth: '700px',
          padding: '16px',
          backgroundColor: 'background.paper',
          zIndex: 1000,
          boxSizing: 'border-box'
        }}
      >
        <CommonButton
          text={intl.formatMessage({ id: "setting_complete_button" })} /* 설정 완료 */
          background={c.primary}
          color={c.text01}
          onClick={handleClickOpen}
        />
      </Box>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CommonLoading text={intl.formatMessage({ id: "setting_sending" })} />
        </div>
      )}
      <CommonDialog
        open={open}
        title={intl.formatMessage({ id:"language_setting_complete_Title" })} /* 언어 설정 완료 */
        subText={intl.formatMessage({ id:"language_setting_complete_Contents_bluetooth" })} /* 포코로와 대화하기 위해 블루투스 연결이 끊어집니다. */
        onClick1={handleClickClose}
        onClick2={handleConfirm}
        LeftButtonText={intl.formatMessage({ id: "dialog_cancle" })}
        RightButtonText={intl.formatMessage({ id: "dialog_confirmButton" })}
      />
    </Root>
  );
}

export default injectIntl(
  inject("authStore")(observer(LanguageSetting))
);
